import moment from "moment";
import { $, pageLoaded } from "venuescanner-js/tools/elemental";
import Details from "venuescanner-js/react/components/SignIn/DetailsContainer";
import { authenticationService } from "./service";

const authService = authenticationService;
authService.updateNavbar = function () {
  const user = this.user;
  const nav = $(".ux-navbar");
  if (!user || !user.name) {
    nav.find(".greeting.mobile").html(`Hi`);
    nav.find(".profile-image").html("Hi");
  } else {
    if (user.lastName) user.lastname = user.lastName;
    nav.find(".greeting.mobile").html(`Hi ${user.name ? user.name : ""}`);
    if (user.joined)
      nav
        .find(".joined.mobile")
        .html(
          user.joined
            ? `On VenueScanner since ${moment(user.joined).format("MMM YYYY")}`
            : "Welcome back"
        );
    if (user.profile_photo) {
      // console.log('prof', user.profile_photo)
      nav
        .find(".profile-image")
        .css({
          backgroundImage:
            'url("https://cdn.venuescanner.com' + user.profile_photo + '")',
        })
        .html("&nbsp;");
    } else {
      const userInitials =
        user.name[0].toUpperCase() +
        (user.lastname ? user.lastname[0].toUpperCase() : "");
      nav.find(".profile-image").html(userInitials);
    }
  }
  if (window.unread) window.unread.init();
};
authService.performAction = async function (onComplete) {
  if (this.user.just_an_invite) {
    const { user } = await this.getDetails();
    Details({ onSaved: onComplete, user });
  }
};

if (typeof window !== "undefined") {
  window.authService = authService;
  pageLoaded(() => {
    authService.updateNavbar();
  });
}
export { authService };
